<template>
  <div class="pagnation-nav">
    <nobr class="buttons">
      <button
        v-for="index in getPageCount"
        :key="index"
        :class="getPaginationTabClass(index - 1)"
        @click="gotoPage(index - 1)">

          {{ index }}
      </button>
    </nobr>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * Requests page change
     * @param {Number} page - Page index [0, inf]
     */
    gotoPage (page) {
      this.$emit('gotoPage', { page })
    },

    /**
     * Gives a class for specific pagination navigation item
     * @param {Number} current Currently looked at element
     * @returns {String}
     */
    getPaginationTabClass (current) {
      let active = this.current
      let base = `pagnation-button`

      if (active === current) {
        base = `${base} active`
      }
      return base
    }
  },

  computed: {
    /**
     * Gives page count
     * @returns {Number}
     */
    getPageCount () {
      return Math.ceil(this.total / this.limit)
    }
  },

  props: {
    total: {
      type: Number,
      required: true,
      default: 0
    },
    limit: {
      type: Number,
      required: true,
      default: 0
    },
    current: {
      type: Number,
      required: true,
      default: 0
    }
  }
}
</script>

<style scoped>
.pagnation-nav {
  overflow-x: scroll;
  margin-top: 15px;
  display: flex;
  align-items: center;
  border-top: 1px solid #E3E3E3;
  border-bottom: 1px solid #E3E3E3;
  height: 50px;
  box-sizing: border-box;
}
.pagnation-nav::-webkit-scrollbar {
  display: none;
}

.pagnation-button {
  background-color: transparent;
  font-size: 13px;
  color: #353635;
  border: none;
  outline: none;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.pagnation-button.active {
  color: #7AC143;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/pagination/Pagination.vue?19863ace